import { render, staticRenderFns } from "./StatusNote.vue?vue&type=template&id=53b1b2ee"
import script from "./StatusNote.vue?vue&type=script&lang=js"
export * from "./StatusNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports